import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import columnStack from './column-stack.svg';
import columnCarousel from './column-carousel.svg';
import { MOBILE_STACKED, MOBILE_CAROUSEL } from './constants';
import styles from './CTA.scss';

export default class CTAMobileBehavior extends React.Component {
  static propTypes = {
    input: PropTypes.shape({
      value: PropTypes.any,
      onChange: PropTypes.func.isRequired,
    }),
  };

  onRadioChange = e => this.props.input.onChange(e.target.value);

  render() {
    const { input: { value } } = this.props;

    return (
      <React.Fragment>
        <Form.Group>
          <span className={styles.option}>mobile column behavior</span>
          <Form.Text className={styles.helpBlock}>
            Test the look of this option by using your mobile device
            or by shrinking down the width of your browser.
          </Form.Text>
          <Form.Group>
            <Form.Check
              type="radio"
              checked={value === MOBILE_STACKED}
              name="mobileBehavior"
              value={MOBILE_STACKED}
              onChange={this.onRadioChange}
              label="Stack columns on top of each other"
            />
            <img src={columnStack} alt="stacked" type="image/svg+xml" width={150} height={150} />
            <Form.Check
              type="radio"
              checked={value === MOBILE_CAROUSEL}
              name="mobileBehavior"
              value={MOBILE_CAROUSEL}
              onChange={this.onRadioChange}
              label="Turn columns into carousel"
            />
            <img src={columnCarousel} alt="carousel" type="image/svg+xml" width={150} height={150} />
          </Form.Group>
        </Form.Group>
      </React.Fragment>
    );
  }
}
